module.exports = __webpack_public_path__ + "static/media/LogoSeuPimenta.de89ef23.png";